// Module
var code = " <gh-grid-cell-editor-container [control]=\"control\"> <div class=\"input-wrapper\"> <input #input=\"\" class=\"cell-input\" [attr.maxlength]=\"maxLength\" [required]=\"required\" [formControl]=\"control\" (blur)=\"onBlur()\" type=\"text\"> </div> </gh-grid-cell-editor-container>";
// Exports
module.exports = code;